import TabBar from './TabBar';
import TabBarItem from './TabBarItem';
TabBar.Item = TabBarItem;
export default TabBar;